module.exports = "<svg viewBox=\"0 0 15 4\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3 3H14V1H1V3Z\" fill=\"white\"></path></svg>"